<template>
  <div>
    <div class="back-title title-bar">
      <i class="el-icon-back c-pointer mr-r4" @click="clickBackButton" style="cursor:pointer"></i> 판단주기 추가
    </div>
    <el-row>
      <el-form label-position="top" :model="eventRscGetintervalFormData" ref="eventRscGetintervalForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="판단주기 ID" prop="eventRscGetintervalId">
              <el-input v-model="eventRscGetintervalFormData.eventRscGetintervalId" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="판단주기명" prop="eventRscGetintervalName">
              <el-input v-model="eventRscGetintervalFormData.eventRscGetintervalName" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="판단주기(초)" prop="rscGetinterval">
            <el-input-number v-model="eventRscGetintervalFormData.rscGetinterval" controls-position="right" placeholder="입력해 주세요." :min="1"></el-input-number></el-input-number>
          </el-form-item>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import msgUtil from '@/utils/message';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';

export default {
  name: 'WAddEventRscGetinterval',
  data() {
    const validateEventRscGetintervalId = (rule, value, callback) => {
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('필수 정보입니다.'));
      } else {
        RuleSettingsAPI.checkEventRscGetintervalIdValidation({
          eventRscGetintervalId: value,
        }).then((response) => {
          if (response.data.data) {
            callback();
          } else {
            callback(new Error('이미 사용 중인 ID입니다.'));
          }
        });
      }
    };
    return {
      rules: {
        eventRscGetintervalId: {
          required: true,
          validator: validateEventRscGetintervalId,
          trigger: 'blur',
        },
        eventRscGetintervalName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        rscGetinterval: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      eventRscGetintervalFormData: {},
    };
  },
  methods: {
    clickBackButton() {
      this.$emit('click-back-button');
    },
    saveButton() {
      this.$refs.eventRscGetintervalForm.validate().then((response) => {
        if (response) {
          const target = '판단 주기';
          const action = msgUtil.action.ADD;
          RuleSettingsAPI.insertRuleEventRscGetinterval(this.eventRscGetintervalFormData).then((addResponse) => {
            if (addResponse.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.cancelButton();
              this.$emit('click-back-button', true);
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
        }
      }).catch(() => {
      });
    },
    cancelButton() {
      this.$refs.eventRscGetintervalForm.resetFields();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/AddEventRscGetinterval.vue